import React from 'react';
import { CTAButton } from './CTAButton';
export function PriceBlock() {
  return <div className="mx-auto flex max-w-2xl flex-col items-center text-center" id="comprar" data-id="element-30">
      <p className="font-display text-3xl text-muted line-through sm:text-4xl" data-id="element-31">
        $107.000 ARS
      </p>
      <p className="mt-4 font-heading text-lg font-bold uppercase tracking-wide text-orange" data-id="element-32">
        🔥 Hoy:
      </p>
      <p className="font-display text-6xl font-extrabold text-soft sm:text-8xl" data-id="element-33">
        $19.900 <span className="text-orange" data-id="element-34">ARS</span>
      </p>
      <p className="mt-3 text-sm text-muted" data-id="element-35">
        💳 Mercado Pago · ⚡ Acceso inmediato · 🛡️ Garantía 7 días · 🔒 Pago
        100% seguro
      </p>
      <div className="mt-8 flex w-full justify-center" data-id="element-36">
        <CTAButton fullWidth pulse data-id="element-37" />
      </div>
    </div>;
}